function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { makeStyles } from '@material-ui/core';
import typography from "../../foundations/typography.module.scss";
import colors from "../../foundations/colors.module.scss";
import shadows from "../../foundations/shadows.module.scss";
import { baseMenuPaperStyles, baseMenuItemStyles } from "../Menu/Menu.styles";
export const useAutocompleteStyles = makeStyles({
  option: _ref => {
    let {
      disableSelectedHighlight
    } = _ref;
    return _objectSpread(_objectSpread({}, baseMenuItemStyles), {}, {
      // Autocomplete-specific overrides
      lineHeight: typography.lineHeightP1,
      // Autocomplete uses data attributes instead of CSS classes
      '&[data-focus="true"]': {
        backgroundColor: disableSelectedHighlight ? "".concat(colors.dark70, " !important") : colors.dark70
      },
      '&[aria-selected="true"]': {
        backgroundColor: disableSelectedHighlight ? 'inherit' : colors.dark120
      },
      '&[aria-disabled="true"]': {
        pointerEvents: 'inherit'
      },
      '&[aria-disabled="true"]:active': {
        pointerEvents: 'none'
      }
    });
  },
  endAdornment: {
    paddingRight: 8
  },
  popper: {
    marginBottom: '4px'
  },
  paper: _objectSpread(_objectSpread({}, baseMenuPaperStyles), {}, {
    // Autocomplete-specific overrides
    backgroundColor: colors.white,
    border: "1px solid ".concat(colors.dark200),
    // Autocomplete uses lighter border color
    borderRadius: 4,
    // Autocomplete uses smaller border radius
    boxShadow: shadows.sh10,
    // Autocomplete uses different shadow
    // Override baseMenuPaperStyles margin (Autocomplete doesn't use margin)
    margin: 0
  }),
  inputRoot: _ref2 => {
    let {
      hasMultipleChips
    } = _ref2;
    return {
      flexWrap: 'wrap',
      paddingTop: hasMultipleChips ? 4 : undefined,
      backgroundColor: colors.dark50,
      '&.MuiOutlinedInput-adornedEnd': {
        paddingRight: '52px !important'
      },
      '& input': {
        width: 0,
        minWidth: 40,
        flexGrow: 1
      }
    };
  }
});